import React from 'react';

const SideNavigation = ({ 
  categories, 
  activeSection, 
  setActiveSection, 
  completionStats,
  contactData,
  errorCounts = {}, // Add errorCounts prop with default empty object
  fileUploadStats = { completed: 0, total: 2 },
  fileUploadsComplete = false
}) => {
  // Check if all fields are completed for validation
  const allFieldsCompleted = Object.values(completionStats).every(
    stat => stat.allRequiredCompleted && stat.requiredTotal > 0
  ) && fileUploadsComplete;

  // Get simplified section name
  const getSectionName = (category) => {
    switch(category) {
      case 'Contact Information':
        return 'Contact';
      case 'Business Information':
        return 'Business';
      case 'File Uploads':
        return 'Files';
      case 'Loan Information':
        return 'Loan';
      case 'Additional Information':
        return 'Additional';
      default:
        return category;
    }
  };

  return (
    <div className="side-navigation">
      
      {/* Contact Info */}
      {contactData && (
        <div className="contact-info">
          <div className="contact-name">
            {contactData.FirstName || ''} {contactData.LastName || ''}
          </div>
          <div className="contact-email">
            {contactData.Email || ''}
          </div>
          <div className="contact-id mt-1">
            <small className="text-muted">ID: {contactData.Id || 'N/A'}</small>
          </div>
        </div>
      )}
      
      {/* Navigation Items */}
      <div className="nav-items">
        {categories.filter(category => category !== 'General').map((category, index) => {
          const stats = completionStats[category] || { completed: 0, total: 0, requiredCompleted: 0, requiredTotal: 0, allRequiredCompleted: false };
          // Consider something complete if all REQUIRED fields are completed, even if optional fields aren't
          const isComplete = stats.allRequiredCompleted && stats.requiredTotal > 0;
          const isActive = activeSection === index;
          const errorCount = errorCounts[category] || 0;
          const sectionName = getSectionName(category);
          
          // Determine if there are validation errors in this category
          // Either from explicit error count or if required completed < required total
          const hasErrors = errorCount > 0 || (stats.requiredCompleted < stats.requiredTotal && stats.requiredTotal > 0);
          
            return (
              <React.Fragment key={category}>
                <div 
                  className={`nav-item ${isActive ? 'active-option2' : ''} ${isComplete ? 'completed' : ''}`}
                  onClick={() => setActiveSection(index)}
                  style={{ position: isActive ? 'relative' : 'static' }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span>{sectionName}</span>
                    <div>
                      {/* Display total count including optional fields, but use color based on required fields only */}
                      <span style={{ color: isComplete ? 'var(--success)' : hasErrors ? 'var(--danger)' : 'var(--primary)' }}>
                        {stats.completed}/{stats.total}
                      </span>
                    </div>
                  </div>
                </div>
                
              {/* File Uploads and Lender Submit for Contact Information only */}
              {category === 'Contact Information' && (
                <>
                  {/* File Uploads Nav Item */}
                <div 
                  className={`nav-item ${activeSection === categories.length + 1 ? 'active-option2' : ''} ${fileUploadsComplete ? 'completed' : ''}`}
                  onClick={() => setActiveSection(categories.length + 1)}
                  style={{ position: activeSection === categories.length + 1 ? 'relative' : 'static' }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Files</span>
                    <div>
                      <span style={{ color: fileUploadsComplete ? 'var(--success)' : 'var(--danger)' }}>
                        {fileUploadStats.completed}/{fileUploadStats.total}
                      </span>
                    </div>
                  </div>
                </div>
                
                  {/* Lender Submit Nav Item */}
                <div 
                  className={`nav-item ${activeSection === categories.length ? 'active-option2' : ''} ${allFieldsCompleted ? 'completed' : ''}`}
                  onClick={() => setActiveSection(categories.length)}
                  style={{ position: activeSection === categories.length ? 'relative' : 'static' }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Submit</span>
                    {allFieldsCompleted ? (
                      <span style={{ color: 'var(--success)' }}>Ready</span>
                    ) : (
                      !fileUploadsComplete && (
                        <span style={{ color: 'var(--danger)' }}>Files Required</span>
                      )
                    )}
                  </div>
                </div>
                </>
              )}
              </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default SideNavigation; 